import React from 'react';

import castArray from 'lodash/castArray';
import PropTypes from 'prop-types';

const FieldError = ({ error }) => {
    if (!error || error.length === 0) return null;

    const errorText = castArray(error).join(', ');

    return (
        <div key="error" className="invalid-feedback d-block">
            { errorText }
        </div>
    );
};

FieldError.propTypes = {
    error: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string),
    ]),
};

export default FieldError;
